export class SimpleErrorObject extends Error {
	constructor(public code: string, public sourceApplication: string = '') {
		super();
		Object.setPrototypeOf(this, SimpleErrorObject.prototype);
	}
}
